import Vue from "vue";
import VueRouter from "vue-router";
//import Home from '../views/Home.vue'

// Pages chargées à la demande (05/10/2026) : le premier chargement ne télécharge plus toute la Caisse.
const Dashboard = () => import("@/components/dashboard")
const PageRendezVous = () => import("@/components/rendez-vous/page-rendez-vous/index.vue") // RDV-002 ; demandes des sites (04/10/2026)
const ChoicePatient = () => import("@/components/choicePatient")
const AllCons = () => import("@/components/all-types-cons")
const AllExamAnalyse = () => import("@/components/all-types-examen-analyse")

const BonConsultation = () => import("@/components/caisse/manage-bons/bon-consultation")
const BonMedical = () => import("@/components/caisse/manage-bons/bon-medical")

const ValiderAll = () => import("@/components/valider-paiement-all")


const PharmacieFacture = () => import("@/components/sans-consultations/facture-pharmacie")
const FactureSoins = () => import("@/components/sans-consultations/facture-soins")
import Login from "@/components/login";

// -----        CAISSE          ------
const Caisse = () => import("@/components/caisse")
const CaisseOuverture = () => import('@/components/caisse/caisse-ouverture')
const BonSortieCaisse = () => import('@/components/caisse/caisse-sortie-bon')
const Versement = () => import('@/components/caisse/caisse-versement')
const VersementsEnAttente = () => import('@/components/caisse/versements-en-attente')
const Depot = () => import('@/components/caisse/depot')
const Ventes = () => import('@/components/caisse/vente/ventes')
// -----------------------------------

// ---------    COMPTABLE    ------------
const Charge = () => import('@/components/comptable/charges')
const Produit = () => import('@/components/comptable/produits')
const Creance = () => import('@/components/comptable/creance')
const Coupon = () => import('@/components/comptable/coupons')
const DepensesCaisse = () => import('@/components/comptable/depenses-caisse')
const GestionCaisse = () => import('@/components/comptable/gestion-caisse')
const Inventaire = () => import('@/components/comptable/inventaires')
const Recouvrement = () => import('@/components/comptable/recouvrements')
const LigneBudgetaire = () => import('@/components/comptable/ligne-budgetaire')
const Dette = () => import('@/components/comptable/dettes')
const JournalCaisse = () => import('@/components/comptable/journal-caisse')
const ListeDemandeAnnulation = () => import('@/components/comptable/demande-annulation')
const TableauDeBord = () => import('@/components/comptable/dashboard')
const DemandeAutorisation = () => import('@/components/comptable/demande-autorisation')


// ----------  TRESORERIE  --------------
const Tresorerie = () => import('@/components/tresorerie/tresorerie')
const DepensePrestataire = () => import('@/components/tresorerie/depense-prestataire')
const Dotation = () => import('@/components/tresorerie/dotation')


// ------       FACTURE     --------
const FactureProforma = () => import('@/components/caisse/facture-proforma')
const ViewFactureProforma = () => import('@/components/caisse/facture-proforma/view-proforma')
const Facture = () => import('@/components/caisse/factures')
const PatientOperation = () => import('@/components/caisse/factures/patients-operations')
const PaiementOperation = () => import('@/components/caisse/factures/paiement')
const ProFacture = () => import('@/components/caisse/factures/pro-facture')
const DetailFacture = () => import('@/components/caisse/factures/view-facture')
// import FactureAssurance from '@/components/caisse/factures/facture-assurance'
const ManageFactureAssurance = () => import('@/components/caisse/factures/facture-assurance/manage-facture')
const DetailRemboursement = () => import('@/components/caisse/factures/facture-assurance/view-facture')
const PrintBon = () => import('@/components/caisse/factures/print-bons')
const CreancePatients = () => import('@/components/caisse/factures/creance-patients')

// Ticket de caisse
const SaleReceipt = () => import('@/components/caisse/factures/ticket-caisse')

// --------   RELIQUAT   --------
const Reliquat = () => import('@/components/caisse/reliquat')

// ------   PARAMETRES   --------
const Profil = () => import('@/components/parametres/profil')
import BlockedUI from '@/components/blocked-ui'
const Parametre = () => import('@/components/parametres/parametre')

// ------   PORTAIL (PORT-001)   --------
const ControleSorties = () => import('@/components/portail/controle-sorties')
import { fermerSession, redirectionPortail } from '@/utils/portail-sorties'

import store from '@/store'
// import authMiddleware from "@/middleware/auth-middleware";
Vue.use(VueRouter);

const cheminAccueil = () => {
    const roleActif = store.getters['activeRole'];
    return roleActif && roleActif.nom === 'ROLE_ADMINISTRATEUR'
        ? '/tableau-de-bord'
        : '/dashboard';
};


const routes = [
    { path: '/guide-utilisation', name: 'GuideUtilisation', component: () => import('@/views/guide-utilisation/index.vue') },
    {
        path: '/blocked',
        name: 'Access Denied',
        component: BlockedUI,
    },

    {
        path: "/",
        name: "Index",
        redirect: cheminAccueil
    },
    {
        path: "/dashboard",
        name: "Tableau de bord",
        component: Dashboard,
    },
    {
        path: "/rendez-vous",
        name: "Rendez-vous",
        component: PageRendezVous,   // RDV-002 : agenda des rendez-vous (Accueil, Caisse) et demandes faites sur les sites
    },
    {
        path: "/rendez-vous/rappels",
        redirect: "/rendez-vous", // anciens favoris : conserver l'agenda sans la page de rappels
    },

    {
        path: "/bon-de-consultation",
        name: "Bon consultation",
        component: BonConsultation,
        props: true
    },

    {
        path: "/bon-medical",
        name: "Bon medical",
        component: BonMedical,
        props: true
    },

    {
        path: "/ventes",
        name: "Vente",
        component: Ventes,
    },

    {
        path: "/ventes/facture-proforma/:proforma_id",
        name: "Proforma",
        component: Ventes,
    },

    {
        path: "/clinicaa/comptabilite/caisse",
        name: "Caisse",
        component: Caisse,
    },
    {
        path: "/clinicaa/comptabilite/caisse/ouverture",
        name: "Ouverture de Caisse",
        component: CaisseOuverture,
    },
    {
        path: "/clinicaa/comptabilite/caisse/sortie-bon",
        name: "Bon de Sortie",
        component: BonSortieCaisse,
    },
    {
        path: "/clinicaa/comptabilite/caisse/versement",
        name: "Versement",
        component: Versement,
    },
    {
        path: "/versements-en-attente",
        name: "versemen-en-attente",
        component: VersementsEnAttente,
    },
    
    {
        path: "/choice-patient",
        name: "choice-patient",
        component: ChoicePatient,
        props: true,
        //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },

    {
        path: "/valider-paiement-all/:passedConsult",
        name: "valider-paiement-all",
        component: ValiderAll,
        props: true
            //component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },

    {
        path: "/factures",
        name: "Factures",
        component: Facture,
        props: true
    },

    {
        path: "/factures/ticket-caisse",
        name: "SaleReceipt",
        component: SaleReceipt,
        props: true
    },

    {
        path: "/factures/imprimer-bons",
        name: "PrintBon",
        component: PrintBon,
        props: true
    },

    {
        path: "/factures/creance-patients",
        name: "CreancePatients",
        component: CreancePatients,
        props: true
    },
    
    {
        path: "/factures/patients-operations",
        name: "Patient-Operation",
        component: PatientOperation,
        props: true
    },
    
    {
        path: "/factures/paiement",
        name: "Paiement-Operation",
        component: PaiementOperation,
        props: true
    },

    {
        path: "/factures/pro-facture",
        name: "ProFacture",
        component: ProFacture,
        props: true
    },

    {
        path: "/factures/detail-facture",
        name: "DetailFacture",
        component: DetailFacture,
        props: true
    },

    // {
    //     path: "/factures/remboursement-assurance",
    //     name: "FactureAssurance",
    //     component: FactureAssurance,
    //     props: true
    // },
    
    {
        path: "/factures/demande-remboursement",
        name: "ManageFactureAssurance",
        component: ManageFactureAssurance,
        props: true
    },

    {
        path: "/factures/detail-remboursement",
        name: "DetailRemboursement",
        component: DetailRemboursement,
        props: true
    },

    {
        path: "/factures/facture-proforma",
        name: "Facture proforma",
        component: FactureProforma,
    },

    {
        path: "/factures/view-proforma/:proforma_id",
        name: "Visualiser Facture proforma",
        component: ViewFactureProforma,
    },

    {
        path: "/reliquat",
        name: "Reliquat",
        component: Reliquat,
        props: true
    },

    // display all type consultations
    {
        path: "/cons-all",
        name: "consultation-all",
        component: AllCons
    },
    {
        path: "/login",
        name: "login",
        component: Login
    },
    {
        path: "/exam-analyse-all/:passed",
        name: "exam-analyse-all",
        component: AllExamAnalyse,
        props: true
    },

    {
        path: "/depots",
        name: "Dépôt",
        component: Depot,
    },

    // +++++++++++      COMPTABLE       +++++++++++++
    {
        path: "/charges",
        name: "Charges",
        component: Charge,
        props: true
    },
    {
        path: "/produits",
        name: "Produits",
        component: Produit,
        props: true
    },
    {
        path: "/creance",
        name: "Creance",
        component: Creance,
        props: true
    },
    {
        path: "/gestion-caisse",
        name: "Gestion de caisse",
        component: GestionCaisse,
        props: true
    },
    {
        path: "/inventaires",
        name: "Inventaires",
        component: Inventaire,
        props: true
    },
    {
        path: "/recouvrements",
        name: "Recouvrement",
        component: Recouvrement,
        props: true
    },
    {
        path: "/pharmacie-facture",
        name: "pharmacie-facture",
        component: PharmacieFacture,
        props: true
    },
    {
        path: "/facture-soins",
        name: "facture-soins",
        component: FactureSoins,
        props: true
    },
    {
        path: "/ligne-budgetaire",
        name: "Ligne Budgetaire",
        component: LigneBudgetaire,
        props: true
    },
    {
        path: "/dettes",
        name: "Dettes",
        component: Dette,
        props: true
    },
    {
        path: "/journal-caisse",
        name: "Journal de caisse",
        component: JournalCaisse,
        props: true
    },

    {
        path: "/tableau-de-bord",
        name: "Admin Board",
        component: TableauDeBord,
        props: true
    },

    {
        path: "/demande-annulation",
        name: "Demande annulation",
        component: ListeDemandeAnnulation,
        props: true
    },

    {
        path: "/demande-autorisation",
        name: "Demande autorisation",
        component: DemandeAutorisation,
        props: true
    },

    // +++++++++  TRESORERIE  ++++++++++
    {
        path: '/depenses',
        name: 'Dépenses prestataires',
        component: DepensePrestataire,
    },
    {
        path: "/tresorerie",
        name: "Tresorerie",
        component: Tresorerie,
        props: true
    },
    {
        path: "/dotation",
        name: "Dotation",
        component: Dotation,
        props: true
    },
    {
        path: "/coupons",
        name: "Coupon",
        component: Coupon,
        props: true
    },
    {
        // Demandes et validations → Dépenses de caisse (administrateur, trésorerie, comptable).
        path: "/depenses-caisse",
        name: "DepensesCaisse",
        component: DepensesCaisse
    },
    {
        path: "/parametres/profil",
        name: "Profil",
        component: Profil,
        props: true
    },

    {
        // Banque directement dans le menu (04/10/2026) ; Sociétés et Exclusions sont dans Clinique › Assurances & Conventions.
        path: "/banque",
        name: "Banque",
        component: Parametre,
        props: true
    },
    {
        path: "/parametres",
        redirect: "/banque", // anciens favoris et guide
    },

    // +++++++++  PORTAIL (PORT-001)  ++++++++++
    {
        path: "/portail/sorties",
        name: "Contrôle des sorties",
        component: ControleSorties,
    },

    {
        path: "/*",
        name: "Not found",
        redirect: cheminAccueil
    }
];

const router = new VueRouter({
    mode: 'history',
    routes,
});
router.beforeEach((to, from, next) => {
    let access = false;
    let role;
    let role_actif
    if (store.getters['authInfo']) {
        role = store.getters['authInfo'].user.roles
        access = false
        for (let index = 0; index < role.length; index++) {
            
            if (
                role[index].nom == "ROLE_COMPTABLE" || role[index].nom == "ROLE_ADMINISTRATEUR" || 
                role[index].nom == "ROLE_TRESORERIE" || role[index].nom == "ROLE_CAISSIERE" ||
                role[index].nom == 'ROLE_ACCUEIL' || role[index].nom == 'ROLE_AGENT_SECURITE'
            ) {
                if (store.getters['activeRole']) {
                    role_actif = store.getters['activeRole'].nom
                    if (
                        role_actif != 'ROLE_CAISSIERE' && role_actif != 'ROLE_ACCUEIL' &&
                        role_actif != 'ROLE_COMPTABLE' && role_actif != 'ROLE_TRESORERIE' &&
                        role_actif != 'ROLE_AGENT_SECURITE'
                    ) {
                        if (role[index].pivot.is_active != true || role[index].pivot.is_active != '1' || role[index].pivot.is_active != 1) {
                            store.dispatch('switchRole', { userId: store.getters['authInfo'].user.id, roleId: role[index].pivot.role_id })
                        } 
                    }
                } else {
                    if (role[index].pivot.is_default == 1) {
                        store.dispatch('switchRole', { userId: store.getters['authInfo'].user.id, roleId: role[index].pivot.role_id })
                    }
                }

                access = true
                break;
            } else {
                access = false
            }
                
        }
    }

    
    if (!store.getters['authInfo'] && to.name != 'login') {
        router.push('/login')
    } else if (access === false && to.name != 'login') {
        router.push('/login')
    } else {
        // PORT-001 : agent de sécurité confiné au contrôle des sorties, session du poste limitée à 12 h.
        const redirection = redirectionPortail(to.path, store.getters['authInfo'], store.getters['activeRole'], Date.now())
        if (redirection && redirection.fermer_session && to.path === '/login') {
            fermerSession(store, typeof localStorage !== 'undefined' ? localStorage : null, false)
        } else if (redirection) {
            return next({ path: redirection.chemin, replace: true })
        }
        // const user_info = store.getters['authInfo']
        
        // const can_login = user_info?.user.can_login

        // if (can_login && can_login == 1) {
            let countdown = {}
            store.dispatch('getCountDown').then((response) => {
                countdown = response
                if (countdown.is_count == 1 && countdown.duree_restant.days < 0) {
                    router.push('/blocked')
                } 
            })
        // }
        store.dispatch('getConfigInfoClinique', 'info_clinique').then((response) => {
            console.log("inf cli: ",response);
        })
        store.dispatch('getConfigInfoClinique', 'currency')
        next()
    }
})

/**
 * Prevent right-click context menu.
 */
document.addEventListener('contextmenu', event => event.preventDefault());

/**
 * Prevent F12 key and other developer tool shortcuts.
 */
document.onkeydown = function (e) {
    // F12
    if (e.keyCode === 123) {
        return false;
    }
    // Ctrl+Shift+I
    if (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0)) {
        return false;
    }
    // Add other shortcuts as needed
};

export default router;
